import React, { useState, useEffect, useRef } from "react"
import MwMonth from "../../components/Common/MwMonth"
import {
  Container,
  Row,
  Card,
  CardBody,
  Col,
  Table,
  Button,
  Modal,
  CardSubtitle,
  CardTitle,
  Input,
} from "reactstrap"
import ReportValidationControls from "../../components/Common/ReportValidation"
import moment from "moment"
import { connect } from "react-redux"
import { withRouter } from "react-router-dom"

import * as backend from "../../helpers/backend_helper"
import { accessFlags, canValidateReport } from "../../common/accessFlags"
import Toaster from "../../components/Common/Toaster"
import * as func from "../../common/functions"
import * as _ from "lodash"
import { saveHealthAndSafety, removeHealthAndSafety } from "../../store/healthAndSafety/action"
import { fileUrl } from "service"

const HealthAndSaftyReport = (props: any) => {
  const thisMonth = moment().format("YYYY-MM")
  const [date, setDate] = useState(thisMonth)
  const [reports, setReport] = useState([])
  const [departments, setDepartments] = useState([])
  const [images, setImages] = useState<any[]>([])
  const [values, setValues] = useState<any[]>([])
  const [formModal_data, setformModal_data] = useState<any>({})
  const [modal_standard, setmodal_standard] = useState(false)
  const [modal_data, setmodal_data] = useState<any>()
  const [submitedBy, setSubmitedBy] = useState<any>({})
  const [validation, setValidation] = useState<any>(null)
  const [downloading, setDownloading] = useState(false)
  // PDF generated by the backend (headless Chrome) and downloaded directly.
  const downloadPdf = async () => {
    setDownloading(true)
    try {
      await backend.downloadReportPdf(
        props.selectedFactory.orgId,
        props.selectedFactory._id,
        "monthlyonsite",
        date,
        `Onsite Inspection - ${String(date).split("-").reverse().join("")}.pdf`
      )
    } catch (e) {
      Toaster.error(typeof e === "string" ? e : "Download failed")
    } finally {
      setDownloading(false)
    }
  }

  function tog_standard() {
    setmodal_standard(!modal_standard)
    removeBodyCss()
  }
  function removeBodyCss() {
    document.body.classList.add("no_padding")
  }

  useEffect(() => {
    // console.log("propsssssssssfdxdfxf", props)
    if (props && props.selectedFactory && props.selectedFactory.healthSafetyReport) {
      let clonedArray = JSON.parse(
        JSON.stringify(props.selectedFactory.healthSafetyReport)
      )

      setDepartments(props.selectedFactory.departments)

      setReport(clonedArray)
      getReport()
    }
  }, [props && props.selectedFactory && props.selectedFactory.healthSafetyReport])

  const getReport = async (newdate?, isFromImage?) => {
    if (props.selectedFactory.healthSafetyReport) {
      const { orgId, _id: facId } = props.selectedFactory
      try {
        let data = await backend.gethealthandsaftyreport(
          orgId,
          facId,
          newdate ? newdate : date
        )

        if (data && Object.keys(data).length > 0) {
          setValidation(data.validation || null)
          if (isFromImage) {
            setImages(data.images)
            setSubmitedBy(data.submitedBy || {})
            getLocalSaveData(newdate ? newdate : date)
          } else {
            setImages(data.images)
            setValues(data.values)
            setSubmitedBy(data.submitedBy || {})
            getLocalSaveData(newdate ? newdate : date)
          }
        } else {
          setValues([])
          setImages([])
          setSubmitedBy({})
          setValidation(null)
          getLocalSaveData(newdate ? newdate : date)
        }
      } catch (e) {
        // On failure, reset to empty for the selected month rather than leaving
        // the previous month's answers in place (which could be overwritten).
        setValues([])
        setImages([])
        setSubmitedBy({})
        Toaster.error(typeof e === "string" ? e : "Failed to load health & safety report")
      }
    }
  }

  function setValue(groupid, questionid, deprtID, type, value) {
    // console.log("oId, idx, e", groupid, questionid, deprtID, type, value)
    let cloneReports = [...values]

    let dataIndex = _.findIndex(cloneReports, value => {
      return (
        value.groupId === groupid &&
        value.questionId === questionid &&
        value.departmentId === deprtID
      )
    })
    if (dataIndex >= 0) {
      if (value) {
        cloneReports[dataIndex].value = value
      } else {
        cloneReports.splice(dataIndex, 1)
      }
      // console.log("datafinddatafind", dataIndex, cloneReports)
    } else {
      cloneReports.push({
        groupId: groupid,
        questionId: questionid,
        departmentId: deprtID,
        type: type,
        value: value,
      })
    }

    // const list = cloneReports[oId].lists[idx]
    // if (list) {
    //   list["value"] = e.target.value
    // }
    setValues([...cloneReports])
    // console.log("cloneReportscloneReports", cloneReports)
  }
  function saveHandS() {
    const { _id: facId } = props.selectedFactory
    const data = {
      facId: facId,
      values: values,
      // submitedBy: submitedBy,
      date: date,
    }
    props.saveHealthAndSafety(data)
    Toaster.success("Report saved Successfully")
  }

  function getLocalSaveData(currentActivedate) {
    const { _id: facId } = props.selectedFactory

    if (
      props.savedHealthAndSafety[facId] &&
      props.savedHealthAndSafety[facId][currentActivedate] &&
      props.savedHealthAndSafety[facId][currentActivedate].date ===
      currentActivedate
    ) {
      // console.log(
      //   "prossin get saved",
      //   props.savedHealthAndSafety[facId][currentActivedate]
      // )
      // setTimeList(
      //   props.dailyWorkReport.dailyWorkReportSave[facId][currentActivedate].list
      // )

      var clonedArraySave = JSON.parse(
        JSON.stringify(
          props.savedHealthAndSafety[facId][currentActivedate].values
        )
      )

      setValues(clonedArraySave)
    }
  }

  async function submit() {
    const { orgId, _id: facId } = props.selectedFactory
    // console.log("selectedFactoryselectedFactory", props.selectedFactory)
    let data = {
      values: values,
      submitedBy: { name: props.user.name, id: props.user["_id"] },
    }
    try {
      await backend.HealthAndSaftyReport(orgId, facId, date, data)

      const removeData = {
        facId: facId,
        // reports: reports,
        // submitedBy: submitedBy,
        date: date,
      }
      console.log("removeData", removeData);


      props.removeHealthAndSafety(removeData)


      getReport(date, true)
      Toaster.success("Report Updated Success")
    } catch (e) {
      console.log("statutoryReport error", e)
      Toaster.error("Report Updated Failed")
    }
  }
  //uploadImage
  async function uploadImage() {
    const { orgId, _id: facId } = props.selectedFactory
    const { departmentId, groupId, questionId } = modal_data

    if (!formModal_data.file || !formModal_data.file[0]) {
      Toaster.error("Please choose a file")
      return
    }

    const formData = new FormData()
    // Update the formData object
    _.each(formModal_data.file, file => {
      formData.append("image", file)
    })
    formData.append("desc", formModal_data.desc || '')
    formData.append("departmentId", departmentId)
    formData.append("groupId", groupId)
    formData.append("questionId", questionId)
    formData.append("date", date)
    try {
      await backend.uploadHealthAndSaftyImage(orgId, facId, formData)
      getReport(date, true)
      tog_standard()
      Toaster.success("Image uploaded successfully")
    } catch (e) {
      Toaster.error(typeof e === "string" ? e : "Image upload failed")
    }
  }

  const deleteImage = (e, img) => {
    e.stopPropagation()

    const { orgId, _id: facId } = props.selectedFactory
    // console.log("imgimgimg", img, orgId, facId)
    let data = {
      date: date,
      imageId: img._id,
    }
    backend
      .deleteHealthAndSaftyImage(orgId, facId, data)
      .then(() => {
        console.log("Sucess")
        getReport(date, true)
        // getDailyMonitoringReport(true)
      })
      .catch(() => {
        console.log("error in delete")
      })
  }

  // Editable only when the user can actually edit THIS report — an org/factory
  // admin or editor, or a member holding the Monthly Onsite report permission —
  // and it isn't already submitted (admins/editors can still edit a submitted
  // one). Read-only (View & Validate) users can never edit. This gates data
  // edits and photo add/delete so a user without edit rights can't change it.
  const _hsPerm: string[] = (props.selectedFactory && props.selectedFactory.permission) || []
  const _canEditHS = _hsPerm.includes("ADMIN") || _hsPerm.includes("EDIT") || _hsPerm.includes("Monthly_onSiteInspection")
  const _isEditor = _hsPerm.includes("ADMIN") || _hsPerm.includes("EDIT")
  const hsEditable = !props.readOnly && _canEditHS && (_isEditor || !(submitedBy && submitedBy.name))

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              marginBottom: "20px",
            }}
          >
            <div style={{ width: 240 }}>
              <MwMonth
                value={date}
                onChange={(val: any) => {
                  setDate(val)
                  getReport(val)
                }}
              />
            </div>
          </div>
          <Row>
            <Col md={4}>
              {submitedBy && submitedBy.name && (
                <span style={{ display: "flex" }}>
                  <h4>Submit By :</h4>{" "}
                  <p style={{ padding: "2px 4px" }} className="ml-2 mr-1">
                    {submitedBy.name}
                  </p>{" "}
                </span>
              )}
              {/* {submitedBy && (
                <Button
                  onClick={handlePrint}
                  style={{ marginLeft: "2px", marginRight: "2px" }}
                  color="success"
                >
                  Print
                </Button>
              )} */}
            </Col>
          </Row>
          {submitedBy && submitedBy.name && (
            <div style={{ marginBottom: 10 }}>
              <ReportValidationControls
                reportType="monthlyonsite"
                dateKey={date}
                orgId={props.selectedFactory.orgId}
                facId={props.selectedFactory._id}
                validation={validation}
                isAdmin={canValidateReport(props.selectedFactory, props.user, "monthlyonsite", submitedBy && submitedBy.id)}
                submitted={!!(submitedBy && submitedBy.name)}
                by={{ id: props.user && props.user["_id"], name: props.user && props.user.name }}
                onChange={setValidation}
              />
            </div>
          )}
          <div style={{ display: "flex", flexWrap: "wrap", gap: "8px", alignItems: "center", marginBottom: "20px" }}>
            {reports.length > 0 && !props.readOnly && (
              <Button onClick={submit} color="success">
                Submit
              </Button>
            )}
            {submitedBy && submitedBy.id && (
              <Button onClick={downloadPdf} disabled={downloading} color="success">
                {downloading ? "Preparing…" : "Download PDF"}
              </Button>
            )}
            {reports.length > 0 && !props.readOnly && (
              <Button onClick={saveHandS} color="success">
                Save
              </Button>
            )}
          </div>
          {reports.length > 0 && (
            <React.Fragment>
              <Row>
                <Col lg={12}>
                  <Card>
                    <CardBody>
                      <CardTitle>Onsite Inspection</CardTitle>
                      {/* <CardSubtitle className="mb-3">
                    Use one of two modifier classNamees to make{" "}
                    <code>&lt;thead&gt;</code>s appear light or dark gray.
                  </CardSubtitle> */}

                      <div className="table-responsive">
                        <Table className="table mb-0 table-bordered table">
                          <thead className="thead-light">
                            <tr>
                              <th>Check Points</th>
                              {departments.map((department: any, key: any) => {
                                return <th key={key}>{department.name}</th>
                              })}
                            </tr>
                          </thead>
                          <tbody>
                            {reports.map((report: any, key: any) => {
                              return (
                                <React.Fragment key={key}>
                                  <tr
                                    className="table-info"
                                    style={{ textAlign: "center" }}
                                  >
                                    <th colSpan={12 + 1} scope="row">
                                      {report.name}
                                    </th>
                                  </tr>
                                  {report.lists.map((que, index) => {
                                    // console.log("que123456", que)

                                    return (
                                      <React.Fragment key={index}>
                                        <tr>
                                          <th scope="row">{que.name}</th>

                                          {departments.map((dept: any, index: any) => {
                                            let specificValue = _.find(
                                              values,
                                              value => {
                                                return (
                                                  value.groupId ===
                                                  report._id &&
                                                  value.questionId ===
                                                  que._id &&
                                                  value.departmentId ===
                                                  dept._id
                                                )
                                              }
                                            )

                                            return (
                                              <React.Fragment key={index}>
                                                {que.type === "select" ? (
                                                  <td>
                                                    <select
                                                      onChange={e => {
                                                        setValue(
                                                          report._id,
                                                          que._id,
                                                          dept._id,
                                                          que.type,
                                                          e.target.value
                                                        )
                                                        console.log(
                                                          "dept id",
                                                          dept
                                                        )
                                                        console.log(
                                                          "question id",
                                                          que
                                                        )
                                                        console.log(
                                                          "group id",
                                                          report
                                                        )
                                                      }}
                                                      //   setValue(oId, idx, e)
                                                      // }
                                                      value={
                                                        specificValue &&
                                                          specificValue.value
                                                          ? specificValue.value
                                                          : ""
                                                      }

                                                      id="ddlCreditCardType"
                                                      name="ddlCreditCardType"
                                                      className="form-control"
                                                    >
                                                      <option value=""></option>
                                                      <option value="yes">
                                                        Yes
                                                      </option>
                                                      <option value="no">
                                                        No
                                                      </option>
                                                      <option value="n/a">
                                                        N/A
                                                      </option>
                                                    </select>
                                                    {specificValue &&
                                                      specificValue.value ===
                                                      "no" && hsEditable && (
                                                        <button
                                                          onClick={e => {
                                                            setmodal_data({
                                                              departmentId:
                                                                dept._id,
                                                              groupId:
                                                                report._id,
                                                              questionId:
                                                                que._id,
                                                            })
                                                            setformModal_data(
                                                              {}
                                                            )
                                                            tog_standard()
                                                          }}
                                                          style={{
                                                            padding: "2px 20px",
                                                            margin: "6px auto",
                                                            display: "block",
                                                          }}
                                                          type="button"
                                                          className="btn btn-danger waves-effect waves-light"
                                                        >
                                                          <i className="mdi mdi-upload d-block font-size-16"></i>{" "}
                                                        </button>
                                                      )}
                                                  </td>
                                                ) : (
                                                  <td>
                                                    <Input
                                                      onChange={e => {
                                                        setValue(
                                                          report._id,
                                                          que._id,
                                                          dept._id,
                                                          que.type,
                                                          e.target.value
                                                        )
                                                      }}
                                                      value={
                                                        specificValue &&
                                                          specificValue.value
                                                          ? specificValue.value
                                                          : ""
                                                      }
                                                      type="text"
                                                      className="form-control"
                                                      id="ddlCreditCardType"
                                                      name="ddlCreditCardType"
                                                    ></Input>
                                                  </td>
                                                )}
                                              </React.Fragment>
                                            )
                                          })}
                                        </tr>
                                      </React.Fragment>
                                    )
                                  })}
                                </React.Fragment>
                              )
                            })}
                          </tbody>
                        </Table>
                      </div>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
              {images.length > 0 && (
                <Row>
                  <Col md={12}>
                    <Card>
                      <CardBody>
                        <CardTitle style={{ paddingLeft: "8px" }}>
                          Remarks (Enclose Evidences)
                        </CardTitle>
                        <div
                          className="popup-gallery"
                          style={{ display: "flex", flexDirection: "column" }}
                        >
                          {departments &&
                            departments.map((depart: any, key: any) => {
                              const find1 = _.find(images, {
                                departmentId: depart._id,
                              })
                              // console.log("departdepartdepart12345",find1 && find1.departmentId===depart._id,find1 ,depart._id)
                              return (
                                <React.Fragment key={key}>
                                  <div style={{ display: "flex", flexWrap: "wrap", gap: "14px", alignItems: "flex-start", marginBottom: find1 ? "16px" : 0 }}>
                                    {images.length > 0 && find1 && (
                                      <div
                                        style={{ width: "100%", fontWeight: 700, color: "#1D3A5F", borderLeft: "4px solid #2EA99B", padding: "2px 0 2px 10px" }}
                                      >
                                        {depart.name}
                                      </div>
                                    )}
                                    {images &&
                                      images.map((image, key) => {
                                        // console.log(
                                        //   "imageimages",
                                        //   image,
                                        //   images
                                        // )
                                        const find = _.find([image], {
                                          departmentId: depart._id,
                                        })
                                        // console.log(find)
                                        if (find) {
                                          let data = _.find(values, value => {
                                            return (
                                              value.groupId === find.groupId &&
                                              value.questionId ===
                                              find.questionId &&
                                              value.departmentId ===
                                              find.departmentId
                                            )
                                          })
                                          // console.log("datajsbdbhdf", data)
                                          // if (data) {
                                          return (
                                            <div
                                              style={{
                                                width: "200px",
                                                border: "1px solid #dfe6ee",
                                                borderRadius: "8px",
                                                overflow: "hidden",
                                                background: "#fff",
                                                position: "relative",
                                              }}
                                              key={key}
                                            >
                                              {find.img && (
                                                <React.Fragment>
                                                  {hsEditable && (
                                                  <button
                                                    type="button"
                                                    title="Remove"
                                                    onClick={e => {
                                                      deleteImage(e, image)
                                                    }}
                                                    style={{
                                                      position: "absolute",
                                                      top: "6px",
                                                      right: "6px",
                                                      border: "none",
                                                      background: "rgba(0,0,0,0.55)",
                                                      color: "#fff",
                                                      borderRadius: "50%",
                                                      width: "22px",
                                                      height: "22px",
                                                      lineHeight: 1,
                                                      cursor: "pointer",
                                                    }}
                                                  >
                                                    &times;
                                                  </button>
                                                  )}
                                                  <img
                                                    style={{ width: "100%", height: "150px", objectFit: "cover", display: "block" }}
                                                    src={find.img.id ? fileUrl(find.img.id) : `data:${find.img.contentType};base64, ${find.img.data}`}
                                                    alt=""
                                                  />
                                                  {find.desc && (
                                                    <p
                                                      style={{
                                                        margin: 0,
                                                        padding: "6px 8px",
                                                        fontSize: "12px",
                                                        color: "#333",
                                                        background: "#f7fafc",
                                                        maxHeight: "64px",
                                                        overflow: "auto",
                                                      }}
                                                    >
                                                      {find.desc}
                                                    </p>
                                                  )}
                                                </React.Fragment>
                                              )}
                                            </div>
                                          )
                                          // }
                                        }
                                      })}
                                  </div>
                                </React.Fragment>
                              )
                            })}
                        </div>
                      </CardBody>
                    </Card>
                  </Col>
                </Row>
              )}
            </React.Fragment>
          )}
        </Container>

        <Modal
          isOpen={modal_standard}
          toggle={() => {
            tog_standard()
          }}
        >
          <div className="modal-header">
            <h5 className="modal-title mt-0" id="myModalLabel">
              {"Upload Documents"}
            </h5>
            <button
              type="button"
              onClick={() => {
                setmodal_standard(false)
              }}
              className="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="modal-body">
            <div className="form-group">
              <input
                type="text"
                className="form-control"
                onChange={event =>
                  setformModal_data({
                    ...formModal_data,
                    desc: event.target.value,
                  })
                }
                placeholder="description"
              />
            </div>
            <div className="custom-file">
              <input
                type="file"
                multiple
                accept="image/jpeg, image/png"
                className="custom-file-input"
                id="customFile"
                onChange={event => {
                  setformModal_data({
                    ...formModal_data,
                    file: event.target.files,
                  })
                }}
              />
              <label className="custom-file-label" htmlFor="customFile">
                {formModal_data && formModal_data.file && formModal_data.file[0]
                  ? formModal_data.file[0].name
                  : "Choose file"}
              </label>
            </div>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              onClick={() => {
                tog_standard()
              }}
              className="btn btn-secondary waves-effect"
              data-dismiss="modal"
            >
              Close
            </button>
            <button
              type="button"
              onClick={() => {
                uploadImage()
              }}
              className="btn btn-primary waves-effect waves-light"
            >
              Save
            </button>
          </div>
        </Modal>
      </div>
    </React.Fragment>
  )
}

// export default

const mapStateToProps = (state, props) => {
  // console.log("state.factory", state.factory, state)
  const { user } = state.user
  const { selected: selectedFactory } = state.factory
  return {
    selectedFactory,
    user,
    ...accessFlags(selectedFactory),
    factories: state.factory.factories,
    savedHealthAndSafety: state.healthAndSafety.saveHealthAndSafety,
  }
}

export default withRouter(
  connect(mapStateToProps, { saveHealthAndSafety, removeHealthAndSafety })(HealthAndSaftyReport)
)
